export default __webpack_public_path__ + "static/media/H0003.dba77f0c.png";